/**
 * L'agent vu depuis l'écran : une porte distante.
 *
 * L'agent tourne dans l'Edge Function `agent` — la clé du modèle n'a rien à
 * faire dans un navigateur. L'application ne fait que lui poser la question,
 * par ce service, qui porte la règle du produit : **l'agent est celui du
 * patron.** L'Edge Function la vérifie aussi de son côté ; ce second contrôle
 * évite seulement d'afficher un panneau qui répondrait « refusé ».
 */
import { ActionLevel } from "../../levels.js";
import { defineService } from "../../service.js";
import type { ExecutionContext } from "../../context.js";
import type { AgentAnswer, AskAgentInput } from "./services.js";

export interface AgentGateway {
  ask(ctx: ExecutionContext, input: AskAgentInput): Promise<AgentAnswer>;
}

export function createAgentGatewayServices(gateway: AgentGateway) {
  const demanderAgent = defineService<AskAgentInput, AgentAnswer>({
    name: "demander_agent",
    level: ActionLevel.Read,
    allowedRoles: ["patron"],
    handler: (ctx, input) => gateway.ask(ctx, input),
  });
  return { demanderAgent };
}

export type AgentGatewayServices = ReturnType<typeof createAgentGatewayServices>;
